var generateStyle = function generateStyle(componentTheme) {
  return {
    marginAdd: {
      margin: componentTheme.marginAddMargin
    },
    quizEntryBankEdit: {
      backgroundColor: componentTheme.quizEntryBankEditBackgroundColor,
      border: "".concat(componentTheme.quizEntryBankEditBorderSize, " dashed ").concat(componentTheme.quizEntryBankEditBorderColor),
      padding: componentTheme.quizEntryBankEditPadding,
      margin: componentTheme.quizEntryBankEditMargin
    },
    quizEntryBankText: {
      textAlign: 'left'
    },
    numberInput: {
      fontSize: componentTheme.numberInputFontSize,
      display: 'inline-flex',
      padding: componentTheme.numberInputPadding,
      paddingBottom: '0',
      paddingLeft: componentTheme.numberInputLeftPadding
    },
    borderLine: {
      marginTop: componentTheme.borderLineTopMargin,
      marginBottom: componentTheme.borderLineBottomMargin,
      borderBottom: "solid ".concat(componentTheme.borderLineBottomBorderSize, " ").concat(componentTheme.borderLineBottomBorderColor)
    }
  };
};
export default generateStyle;